import { showDialog, subscribeDialog, type DialogRequest } from '@src/components/Dialog/Dialog';

/** Half-height draggable sheet on phones; normal dialog on larger screens.
 * Shares DialogHost focus management, inert background, actions and Escape. */
export function showSheet(request: Omit<DialogRequest, 'mobileSheet' | 'mobileFullScreen' | 'fullScreen'>) {
  const trigger = document.activeElement instanceof HTMLElement ? document.activeElement : null;
  const sheetRequest: DialogRequest = { ...request, mobileSheet: true, onCancel: () => {
    request.onCancel?.();
    const unsubscribe = subscribeDialog(next => {
      if (next === sheetRequest) return;
      requestAnimationFrame(() => {
        unsubscribe();
        requestAnimationFrame(() => { if (trigger?.isConnected) trigger.focus({ preventScroll: true }); });
      });
    });
  } };
  showDialog(sheetRequest);
}
